module.exports = __webpack_public_path__ + "img/m_top_overview.7653fe6d.jpg";